import { TableName } from '@openx/components-table/Table.tsx';
import { CriteriaDimension, SortDirection } from '@openx/types/tableCriteria.ts';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { useDealInsightsContext } from '../../../../../context/DealInsightsContext.tsx';
import { sortAdSizeDataByLabel } from '../utils/adSizeLabels.ts';

export const useDeliveryByAdSizeTableData = () => {
  const { dealInsights, criteria } = useDealInsightsContext();
  const { data, chartsLoadingState } = dealInsights;

  const transformedData =
    data?.delivery_by_ad_size.objects.map(item => {
      const sovPercentage = item.sov !== null ? item.sov * 100 : null;
      const ctrPercentage = item.ctr !== null ? item.ctr * 100 : null;
      const viewabilityPercentage =
        item.viewability !== null && item.viewability !== undefined ? item.viewability * 100 : null;

      return {
        ...item,
        spend_raw: item.spend,
        sov_raw: item.sov,
        ecpm_raw: item.ecpm,
        ctr_raw: item.ctr,
        viewability_raw: item.viewability ?? null,
        impressions_raw: item.impressions,
        // Formatted values for display
        ecpm: abbreviateNumericValue(item.ecpm, { allowZero: true, nullValue: 'N/A' }),
        sov: abbreviateNumericValue(sovPercentage, { allowZero: true, nullValue: 'N/A' }),
        spend: abbreviateNumericValue(item.spend, { allowZero: true, nullValue: 'N/A' }),
        ctr: abbreviateNumericValue(ctrPercentage, { allowZero: true, nullValue: 'N/A' }),
        viewability: abbreviateNumericValue(viewabilityPercentage, { allowZero: true, nullValue: 'N/A' }),
        impressions: abbreviateNumericValue(item.impressions, { allowZero: true, nullValue: 'N/A' }),
      };
    }) ?? [];

  let sortedData = transformedData;
  if (criteria?.[TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE]) {
    const tableCriteria = criteria[TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_SIZE];
    const sortCriteria = tableCriteria?.[CriteriaDimension.SORT];

    if (sortCriteria?.column) {
      if (sortCriteria.column === 'ad_size') {
        // Use predefined order for ad_size column
        sortedData = sortAdSizeDataByLabel(transformedData, sortCriteria.direction);
      } else {
        const sortKey = `${sortCriteria.column}_raw`;
        sortedData = [...transformedData].sort((a, b) => {
          const valueA = a[sortKey] as number;
          const valueB = b[sortKey] as number;

          const comparison = valueA - valueB;
          return sortCriteria.direction === SortDirection.DESC ? -comparison : comparison;
        });
      }
    }
  }

  return {
    data: sortedData,
    isLoading: !!chartsLoadingState.delivery_by_ad_size,
  };
};
